import { render, staticRenderFns } from "./SendInquiry.vue?vue&type=template&id=9bad2096&"
import script from "./SendInquiry.vue?vue&type=script&lang=js&"
export * from "./SendInquiry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports